/** Toast thông báo ngắn (M3). */
import { useEffect, useState } from 'preact/hooks';

export interface ToastMsg {
  id: number;
  text: string;
}

let demId = 0;
const nguoiNghe = new Set<(msg: ToastMsg) => void>();

/** Gọi từ bất kỳ đâu để hiện toast. */
export function toast(text: string): void {
  const msg = { id: (demId += 1), text };
  for (const fn of nguoiNghe) fn(msg);
}

export function Toasts() {
  const [ds, setDs] = useState<ToastMsg[]>([]);
  useEffect(() => {
    const fn = (msg: ToastMsg): void => {
      setDs((cu) => [...cu.slice(-2), msg]);
      setTimeout(() => setDs((cu) => cu.filter((m) => m.id !== msg.id)), 3500);
    };
    nguoiNghe.add(fn);
    return () => {
      nguoiNghe.delete(fn);
    };
  }, []);
  if (ds.length === 0) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '64px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 60,
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        pointerEvents: 'none',
      }}
    >
      {ds.map((m) => (
        <div
          key={m.id}
          style={{
            background: 'rgba(20, 14, 8, 0.92)',
            color: '#ffe9b0',
            border: '1px solid #c98a2e',
            borderRadius: '8px',
            padding: '8px 14px',
            fontSize: '14px',
            whiteSpace: 'nowrap',
          }}
        >
          {m.text}
        </div>
      ))}
    </div>
  );
}
